import Router from "../router";
import { store } from "../store/store";

const actionsScope = [
  "open-process",
  "send-process-report",
  "edit-process-start-time", // Cualquiera menos alfaberries
  "edit-process-end-time", // Cualquiera menos alfaberries
  "puede-cambiar-prioridad-op",
  "primero-selecciona-descripcion-y-luego-formato", // wishfarms
  "mostrar-certificaciones-en-modal-lote", //wishfarms
  "puede-resetear-contrasena",
  "puede-modificar-layout",
  "puede-ver-qc-en-stock",
  "bluefields-stock-cajas", // bluefields
  "se-le-agrega-columna-interplanta-en-lista-de-guias", // masberries
  "puede-agregar-pallets-sin-aprobar-en-packing-list-embarque",
  "superusuario-puede-cambiarse-de-cliente",
  "comex:download_shipment_pdf", // Instructivo PDF de Imperial
  "comex:upload_export_invoice", // Subir factura exportacion de Imperial
  "dashboard_comercial:ver_todo",
  "puede-cambiarse-de-planta", // Para que pueda cambiarse de planta
  "puede-ver-peso-promedio-bandeja" // En el model que crea los pallets
];

const scope = function () {
  // Get from vuex user
  const user = store.getters.user;
  const isSuperUser = user.SUPERUSER;

  let routerScope = [];
  if (isSuperUser) {
    console.log("Logged user is superuser");
    Router.options.routes[0].children.forEach((item) => {
      routerScope.push(item.name);
      if (item.children) {
        item.children.forEach((child) => {
          if (child.children) {
            child.children.forEach((grandChild) => {
              routerScope.push(grandChild.name);
            });
          }
          routerScope.push(child.name);
        });
      }
    });
    routerScope.push(...actionsScope);
  } else {
    routerScope = user.scope;
  }
  // console.log("ACAACK!!! 🐔", routerScope);

  return routerScope;
};

export default scope;
